import MarketingShell from "@/components/marketing/MarketingShell";

export default function About() {
    return (
        <MarketingShell
            title="About — Furmais | The AI Production OS"
            description="Furmais is built from real-world production experience. Learn how an AI-led workflow turns ideas into structured creative execution for agencies, studios, and brands."
            ogTitle="About Furmais"
            ogDescription="A production system built from real-world industry experience."
        >
            <article className="relative z-10 px-6 sm:px-10 pt-12 pb-24 max-w-3xl mx-auto" data-testid="about-page">
                <div className="label-micro mb-3 text-[#FF4400]">About</div>
                <h1 className="font-display text-4xl sm:text-5xl tracking-tight mb-8">About Furmais</h1>
                <p className="text-zinc-300 text-base leading-relaxed mb-6">
                    Furmais is an AI-powered production operating system designed to transform
                    ideas into structured creative execution. It combines strategy, research,
                    writing, storyboarding, and production planning into one intelligent
                    workflow.
                </p>
                <p className="text-zinc-300 text-base leading-relaxed mb-12">
                    Unlike traditional tools, Furmais doesn&apos;t just assist —
                    it <span className="text-white">orchestrates</span>. From a simple brief,
                    it builds a complete production-ready pipeline used by agencies, creators,
                    studios, and brands.
                </p>

                <hr className="border-zinc-900 my-12" />

                {/* FOUNDER STORY */}
                <section data-testid="about-founder">
                    <div className="label-micro mb-3">Founder story</div>
                    <h2 className="font-display text-3xl sm:text-4xl tracking-tight mb-6">
                        Built from real production experience.
                    </h2>
                    <p className="text-zinc-300 text-base leading-relaxed mb-5">
                        Furmais is created by <span className="text-white">Mrunal Shukla</span>,
                        founder of <span className="text-white">RIFA Productions</span>, with deep
                        roots in creative production, post-production, and advertising workflows.
                    </p>
                    <p className="text-zinc-300 text-base leading-relaxed mb-5">
                        After working closely with agencies, brands, and film production
                        processes, one challenge remained constant — turning ideas into
                        structured execution took time, coordination, and multiple teams.
                    </p>
                    <p className="text-zinc-300 text-base leading-relaxed mb-5">
                        Furmais was built to solve that gap.
                    </p>
                    <p className="text-zinc-300 text-base leading-relaxed mb-5">
                        It brings together the thinking of strategists, the direction of
                        creatives, and the execution flow of production — into one unified
                        AI-powered system.
                    </p>
                    <p className="text-zinc-100 text-lg leading-relaxed font-medium border-l-2 border-[#FF4400] pl-4 my-8">
                        This is not just an AI tool.<br />
                        It is a production system built from real-world industry experience.
                    </p>
                </section>

                <hr className="border-zinc-900 my-12" />

                {/* VISION & MISSION */}
                <section className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="about-vision-mission">
                    <div className="border border-zinc-900 bg-[#080808] rounded-sm p-6">
                        <div className="label-micro mb-3 text-[#FF4400]">Vision</div>
                        <p className="text-zinc-200 leading-relaxed">
                            To become the operating system for content creation — where any idea
                            can be transformed into structured, production-ready output.
                        </p>
                    </div>
                    <div className="border border-zinc-900 bg-[#080808] rounded-sm p-6">
                        <div className="label-micro mb-3 text-[#FF4400]">Mission</div>
                        <p className="text-zinc-200 leading-relaxed">
                            To simplify and accelerate creative production by combining strategy,
                            intelligence, and execution into one seamless AI-powered workflow.
                        </p>
                    </div>
                </section>
            </article>
        </MarketingShell>
    );
}
